import { ThemedText } from '@/components/themed-text';
import type { ComparisonPage } from '@/content/seo/comparisons';
import React from 'react';
import { View } from 'react-native';
import { CheckList } from './guide-section';
import { Reveal } from './seo-blocks';
import { SemanticTable } from './semantic-table';

export const PAID_MARK = '(planos pagos)';

/** Cabeçalho da nossa coluna. */
export const usLabelOf = (page: ComparisonPage) => page.usLabel ?? 'Controlapag';

/** Linhas da tabela como texto: o recurso pago leva "(planos pagos)" na célula. */
export const comparisonRows = (page: ComparisonPage): string[][] =>
  page.rows.map((row) => [row.criterion, row.paid ? `${row.us} ${PAID_MARK}` : row.us, row.them]);

/**
 * Lado a lado. Na web é `<table>` de verdade (`SemanticTable`), com a nossa
 * coluna destacada; no app nativo, um cartão por critério.
 */
export function ComparisonTable({ page }: { page: ComparisonPage }) {
  return (
    <SemanticTable
      caption={`${usLabelOf(page)} ou ${page.otherWithArticle}: comparação por critério`}
      columns={[{ label: 'Critério' }, { label: usLabelOf(page), highlight: true }, { label: page.other }]}
      rows={comparisonRows(page)}
    />
  );
}

/** "Escolha X se" dos dois lados, em cartões vizinhos. */
export function ChooseCards({ page }: { page: ComparisonPage }) {
  const usTitle = page.chooseUsTitle ?? 'Escolha a Controlapag se';
  const themTitle =
    page.chooseThemTitle ??
    (page.kind === 'manual' ? `Fique com ${page.otherWithArticle} se` : `Escolha ${page.otherWithArticle} se`);
  return (
    <View className="gap-4 md:flex-row">
      <Reveal className="flex-1 rounded-2xl border border-primary-100 bg-primary-50 p-5 md:p-6">
        <ThemedText role="heading" aria-level={2} className="mb-4 font-bold text-lg">
          {usTitle}
        </ThemedText>
        <CheckList items={page.chooseUs} />
      </Reveal>
      <Reveal delay={80} className="flex-1 rounded-2xl border border-neutral-900/5 bg-card p-5 md:p-6">
        <ThemedText role="heading" aria-level={2} className="mb-4 font-bold text-lg">
          {themTitle}
        </ThemedText>
        <CheckList items={page.chooseThem} />
      </Reveal>
    </View>
  );
}
